import { Button, Modal, NumberInput } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useState, useEffect } from 'react'
import { useAxiosApi } from '@/hooks/useAxiosApi'

export default function ShopifyVariantPriceEdit({
    product,
    variant,
    fetchProduct,
}) {
    const [opened, { open, close }] = useDisclosure(false)
    const [isSaving, setIsSaving] = useState(false)
    const { requestPatch } = useAxiosApi()

    const [priceGBP, setPriceGBP] = useState(variant.price_gbp)
    const [priceUSD, setPriceUSD] = useState(variant.price_usd)

    const saveChildren = async () => {
        setIsSaving(true)

        await requestPatch(`/shopify/variants/${variant.id}`, {
            price_gbp: priceGBP > 0 ? priceGBP : null,
            price_usd: priceUSD > 0 ? priceUSD : null,
        })

        await fetchProduct()
        close()
    }

    useEffect(() => {
        if (opened) {
            setIsSaving(false)
            setPriceGBP(variant.price_gbp)
            setPriceUSD(variant.price_usd)
        }
    }, [opened, variant.price_gbp, variant.price_usd])

    const formatPrice = (price) => {
        const formatter = new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
        })

        return formatter.format(price)
    }

    return (
        <>
            <Modal
                opened={opened}
                position="right"
                onClose={close}
                size="xl"
                title={'Prix de retail : ' + product.title + ' - ' + variant.title}
            >
                <div className="flex flex-col">
                    <div className="flex flex-col gap-2">
                        <div className="flex flex-col">
                            <span className="font-medium text-sm">
                                Prix Shopify HT
                            </span>

                            <span className="mt-1">
                                {formatPrice(variant.price)}
                            </span>
                        </div>

                        <NumberInput
                            label="Prix de retail UK"
                            description="Prix en TTC"
                            suffix=" £"
                            decimalScale={2}
                            fixedDecimalScale
                            decimalSeparator=","
                            min={0}
                            value={priceGBP}
                            onChange={(value) => setPriceGBP(value)}
                        />

                        <NumberInput
                            label="Prix de retail US"
                            description="Prix HT"
                            suffix=" $"
                            decimalScale={2}
                            fixedDecimalScale
                            decimalSeparator=","
                            min={0}
                            value={priceUSD}
                            onChange={(value) => setPriceUSD(value)}
                        />
                    </div>

                    <div className="flex gap-2 ml-auto mt-5">
                        <Button onClick={close} variant="default">
                            Annuler
                        </Button>

                        <Button onClick={saveChildren} loading={isSaving}>
                            Sauvegarder les modifications
                        </Button>
                    </div>
                </div>
            </Modal>

            <Button variant="default" onClick={open} className="mt-2 mr-auto">
                Modifier les prix de retail
            </Button>
        </>
    )
}